import { render, staticRenderFns } from "./HelloInicio.vue?vue&type=template&id=5c8d49a2"
import script from "./HelloInicio.vue?vue&type=script&lang=js"
export * from "./HelloInicio.vue?vue&type=script&lang=js"
import style0 from "./HelloInicio.vue?vue&type=style&index=0&id=5c8d49a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports